$(function () {
    var offset = 64;
    if($(".sub_site_header").length) {
        offset = 70;
    }
    $.getHeaderTopOffset = $.fn.getHeaderTopOffset = function () {

        var breadcrumbOffsetTop = $('.header-tail').offset().top;
        var headerOffsetTop = breadcrumbOffsetTop - offset - 1;

        return headerOffsetTop;
    }
});
